import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn, UserPlus, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { GlassCard } from '../shared';

/**
 * AuthPrompt — appel à l'action pour se connecter ou s'inscrire
 * Affiché quand l'utilisateur n'est pas authentifié
 */
export const AuthPrompt = () => {
  return (
    <GlassCard 
      className="bg-gradient-to-br from-primary/20 via-primary/10 to-background border-primary/40 overflow-hidden"
      data-testid="mobile-auth-prompt"
    >
      <div className="p-4 text-center">
        <div className="flex justify-center mb-3">
          <Sparkles className="w-8 h-8 text-primary" />
        </div>
        
        <h3 className="text-lg font-serif text-text-primary mb-2">
          Bienvenue sur Noor Al-Bayan
        </h3>
        
        <p className="text-sm text-text-secondary mb-4">
          Connectez-vous pour suivre votre progression, sauvegarder vos favoris et accéder à tous les outils d'apprentissage.
        </p>

        <div className="flex gap-2">
          <Link to="/login" className="flex-1">
            <Button variant="outline" className="w-full">
              <LogIn className="w-4 h-4 mr-2" />
              Se connecter
            </Button>
          </Link>
          <Link to="/register" className="flex-1">
            <Button className="w-full bg-primary text-white">
              <UserPlus className="w-4 h-4 mr-2" />
              S'inscrire
            </Button>
          </Link>
        </div>
      </div>
    </GlassCard>
  );
};

export default AuthPrompt;
